import { cn, DisplayClock, RoomTape } from "@scribenote/brian-design-system";
import { Link, type LinkProps } from "@tanstack/react-router";
import type { ReactNode } from "react";

/** `homeTo` makes the tapes a link back to the display's home page. */
export const DisplayFrame = ({
  tapes,
  homeTo,
  actions,
  children,
}: {
  tapes: string[];
  homeTo?: LinkProps["to"];
  actions?: ReactNode;
  children: ReactNode;
}) => {
  const tapeRow = tapes.map((tape) => <RoomTape key={tape}>{tape}</RoomTape>);

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-5 px-8 pt-7 pb-24">
      <header className="grid shrink-0 grid-cols-[1fr_auto_1fr] items-center gap-6">
        <div className="flex items-center gap-3">
          {homeTo ? (
            <Link
              to={homeTo}
              data-dd-action-name={`Display home: ${tapes.join(" ")}`}
              className={cn(
                "flex cursor-pointer items-center gap-3 rounded-[2px]",
                "transition duration-150 ease-paper hover:opacity-80",
                "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent",
              )}
            >
              {tapeRow}
            </Link>
          ) : (
            tapeRow
          )}
          <DisplayClock className="ml-2" />
        </div>
        {actions ?? <span />}
      </header>
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
    </div>
  );
};
